import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { PaginationComponent } from './pagination.component';
import { PaginationService } from './pagination.service';

@NgModule({
  declarations: [PaginationComponent],
  exports: [PaginationComponent],
  imports: [CommonModule, NgbPaginationModule, FormsModule, NgbModule, TranslateModule],
  providers: [],
})
export class PaginationModule {
  static forRoot(): ModuleWithProviders<PaginationModule> {
    return {
      ngModule: PaginationModule,
      providers: [PaginationService],
    };
  }
}
